
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger': {
    width: 137,
    height: 130,
    viewBox: '0 0 137 130',
    data: '<path pid="0" d="M127 130H10c-5.5 0-10-4.5-10-10s4.5-10 10-10h117c5.5 0 10 4.5 10 10s-4.5 10-10 10zm0-55H10C4.5 75 0 70.5 0 65s4.5-10 10-10h117c5.5 0 10 4.5 10 10s-4.5 10-10 10zm0-55H10C4.5 20 0 15.5 0 10S4.5 0 10 0h117c5.5 0 10 4.5 10 10s-4.5 10-10 10z"/>'
  }
})
